var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"group"},[_vm._v("\n    "+_vm._s(_vm.group.name)+"\n    "),_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v("\n      "+_vm._s(_vm.group.activeLocationCount)+" / "+_vm._s(_vm.group.locationCount)+" 地点\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }